import { omit } from 'lodash/fp';

import {
    USER_ANALYTICS_SET,
    USER_ANALYTICS_TRACKER_DELETE,
    USER_ANALYTICS_TRACKER_UPDATE,
} from '../../common/users/userAnalyticsConstants';
import { CURRENT_USER_SET_GUEST } from './currentUserConstants';
import { LOGOUT } from '../auth/authConstants';
import {
    MNUserAnalytics,
    MNUserAnalyticsTracker,
    MNUserAnalyticsTrackerState,
    PendingEvent,
    UserAnalyticsTrackerType,
} from '../../common/users/userAnalyticsTypes';

const initialState: MNUserAnalytics = {};

const toUserAnalyticsMap = (trackerDocuments?: MNUserAnalyticsTracker[]): MNUserAnalytics => {
    if (!trackerDocuments?.length) return initialState;

    return trackerDocuments.reduce((analytics: MNUserAnalytics, trackerDocument) => {
        analytics[trackerDocument.trackerType] = trackerDocument;
        return analytics;
    }, {});
};

export default (
    state = initialState,
    action: {
        type: string;
        analytics?: MNUserAnalyticsTracker[];
        pendingEvent?: PendingEvent;
        trackerType?: UserAnalyticsTrackerType;
        state?: MNUserAnalyticsTrackerState;
    },
) => {
    switch (action.type) {
        case LOGOUT:
        case CURRENT_USER_SET_GUEST:
            return initialState;
        case USER_ANALYTICS_SET:
            return toUserAnalyticsMap(action.analytics);
        case USER_ANALYTICS_TRACKER_UPDATE: {
            const { trackerType } = action;
            if (!trackerType || !state[trackerType]) return state;

            return {
                ...state,
                [trackerType]: {
                    ...state[trackerType],
                    ...(action.state ? { state: action.state } : {}),
                    ...(action.pendingEvent ? { pendingEvent: action.pendingEvent } : {}),
                },
            };
        }
        case USER_ANALYTICS_TRACKER_DELETE:
            return action.trackerType ? omit([action.trackerType], state) : state;
        default:
            return state;
    }
};
